import { useSuspenseQuery } from "@tanstack/react-query"
import { userQueryOptions } from "../auth/user-query"
import type { User } from "./types"
import { useCurrentUserId } from "./use-current-user-id"

/**
 * The current user from `byId`, following every cache update (`useUpdateUser`
 * writes there via `setQueryData`). The root check has already put the user
 * in the cache, so it does not suspend.
 *
 * Use it for showing user fields and for logic on the current user state
 * (paywall guards, premium checks).
 *
 * Do not use it for the initial values of editor screens with `isDirty` — a
 * reactive source breaks dirty detection; use {@link useCurrentUserSnapshot}.
 */
export function useCurrentUser(): User {
	return useSuspenseQuery(userQueryOptions(useCurrentUserId())).data
}

/**
 * Активна ли платная подписка у текущего юзера.
 * Обёртка над {@link useCurrentUser} — реактивна к mutations.
 */
export function useIsPremium(): boolean {
	return useCurrentUser().subscription.active
}
